import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ExportDetailSection from 'features/exports/sections/ExportDetailSection';

type RouteProps = {
  exportDefinitionId: string;
}

const ExportDetailPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { exportDefinitionId } = useParams<RouteProps>();

  // render
  return (
    <>
      <Header
        title={tLabels("exportDetailPage.title")}
        includeBreadcrumbs
        links={[
          { to: "/exports", text: tLabels("exports.title") },
        ]}
      />
      <ModuleContent>
        <ExportDetailSection 
          exportDefinitionId={exportDefinitionId}
        />
      </ModuleContent>
    </>
  );
}

export default ExportDetailPage;